import Swiper from 'swiper';
import 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const initBlock = function( $block ) {
	$block.each( function() {
		const $sectionInstance = $( this );
		const $slider = $sectionInstance.find( '.js-member-podcast-slider' );

		if ( !$slider.length || $slider[0].swiper ) {
			return;
		}

		new Swiper( $slider[0], {
			slidesPerView: 1,
			spaceBetween: 20,
			speed: 1000,
			slidesPerGroup: 1,
			watchOverflow: true,
			navigation: {
				nextEl: $slider.find( '.swiper-button-next' )[0],
				prevEl: $slider.find( '.swiper-button-prev' )[0],
			},
			breakpoints: {
				1025: {
					slidesPerView: 2,
				},
				1280: {
					slidesPerView: 3,
				},
				1720: {
					slidesPerView: 5,
				},
			},
		} );
	} );
};

app.loadBlock( initBlock, 'member-podcast-slider', '.section-member-podcast-slider' );

if ( module.hot ) {
	module.hot.accept();
}
